(function(module) {
    'use strict';

    function TermsCheckCtrl($state, Store, Account, $scope, $rootScope, $location, $stateParams, $window) {
        this.$onInit = () => {
        };
        this.accept = () => {
            const date = Date.now();

            Account.prototype$patchAttributes(
                { id: this.account.id },
                { agreementSigned: true, agreementSignedDate: date })
                .$promise
                .then((account) => {
                    if ($stateParams.redirectUrl) {
                        $window.location.href = $stateParams.redirectUrl;
                    } else {
                        $state.go('root.home');
                    }
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

    }

    module
        .config(function($stateProvider) {

            // Route
            $stateProvider
                .state('terms-check', {
                    url: '/terms-check?redirect=:redirectUrl',
                    data: {
                        pageTitle: 'Terms check',
                    },
                    views: {
                        'main@': {
                            templateUrl: '/js/components/layouts/content-only.html',
                            controller: 'MainController as vm',
                        },
                        'content@terms-check': {
                            template: '<terms-check-component account="$resolve.account" />',
                        },
                    },
                    params: {
                        redirectUrl: {
                            value: null,
                            squash: false,
                        },
                    },
                    resolve: {
                        currentUser: function(User) {
                            return User.getCurrent().$promise.then(function(response) {
                                return response;
                            });
                        },
                        account: function(currentUser, Account, $state, Store, $stateParams, $window) {
                            const accountId = currentUser.accountId;
                            return Account.findById({ id: accountId })
                                .$promise
                                .then(function(account) {
                                    if (account.enabled && account.accountVerified && account.agreementSigned) {

                                        if ($stateParams.redirectUrl) {
                                            $window.location.href = $stateParams.redirectUrl;

                                        } else {
                                            $state.go('root.home');

                                        }
                                    }
                                    return account;

                                });

                        },
                    },

                    bodyClass: 'page--terms-check',

                    // Translations
                    // $translatePartialLoaderProvider.addPart('/js/authentication/conditions');

                });
        })
        .component('termsCheckComponent', {
            templateUrl: '/js/authentication/terms-check/terms-check.html',
            controller: TermsCheckCtrl,
            bindings: {
                account: '<',
            },
        });

})

(angular.module('rocket.components'));
